const DEFAULT_SIZE = 's16'

const iconSize = {
    xs: 's8',
    s: 's12',
    m: 's16',
    l: 's24',
    xl: 's32',
    '2xl': 's48',
    '3xl': 's64',
    '4xl': 's80',
}

export const withSize =
    WrappedComponent =>
    ({ size, ...props }) => {
        return <WrappedComponent {...props} size={iconSize[size] || size || DEFAULT_SIZE} />
    }
